<template lang="pug">
  div
    v-bottom-sheet(hide-overlay persistent no-click-animation v-model="showListSheet")
      template(v-slot:activator="{ on }")
        //- 地図
        div
          GoogleMap.googlemap(
              v-if="initLocation"
              :class="{'full': !showListSheet}"
              :marker="markerList"
              :location="initLocation"
              :zoom="$store.state.apps.mapDefaultZoom"
              @mapMove="onMapMove"
              @mapZoom="onMapZoom")
          v-btn(fab dark fixed bottom right @click="showListSheet = !showListSheet" v-if="!showListSheet")
            v-icon|fa-caret-up

      //- 店舗リスト
      div.shop-list
        router-view(v-bind:marker="markerList")
        v-btn(fab dark absolute top right @click="showListSheet = !showListSheet")
          v-icon|fa-caret-down
</template>

<script>
import GoogleMap from '@/components/GoogleMap/GoogleMap'

var AsyncLock = require('async-lock')

export default {
  components: {
    GoogleMap
  },
  data () {
    return {
      // 排他ロック
      lock: new AsyncLock(),
      // 店舗リスト
      markerList: [],
      // 店舗リスト表示の有無
      showListSheet: true,
      // 初期表示の位置情報
      initLocation: null,
      // 読込完了した設定（画面に表示中）
      loadedConfig: null,
      // 読込対象の設定（画面に表示前）
      loadConfig: null,
      // エリアデータ
      areaData: null,
      // 期間（From）
      dateFrom: null,
      // 期間（To）
      dateTo: null,
      // 荷物数
      quantity: null
    }
  },
  created () {
    this.readLocation()
  },
  watch: {
    /**
     * 言語
     */
    '$store.state.apps.language' () {
      // 地図の言語を後から変更できない
      // ページリロードで地図を再読込
      this.utils.sleep.sleep(1)
        .then(() => {
          location.reload()
        })
    }
  },
  methods: {
    /**
     * 位置情報を読込
     */
    readLocation () {
      const init = new Promise((resolve, reject) => {
        this.areaData = this.$store.getters.forms_search.areaData
        if (this.areaData && this.areaData.mapLatitude && this.areaData.mapLongitude) {
          // 指定したエリアの緯度経度
          this.initLocation = {
            lat: this.areaData.mapLatitude,
            lng: this.areaData.mapLongitude
          }
          resolve()
        } else {
          // エリア未選択は現在地
          this.$store.dispatch('geo_read')
            .then(() => {
              this.initLocation = this.$store.getters.geo_location
              resolve()
            })
        }
      })

      init.then(() => {
        this.lock.acquire('loadConfig', () => {
          this.loadConfig = {
            lat: this.initLocation.lat,
            lng: this.initLocation.lng,
            radius: this.zoomToRadius(this.$store.state.apps.mapDefaultZoom)
          }
        }).then(() => {
          this.loadShop()
        })
      })
    },
    /**
     * 店舗読込
     */
    loadShop () {
      const reload = this.$store.state.apps.shopReloadLocation

      this.lock.acquire('loadShop', () => {
        let config = null
        return this.lock.acquire('loadConfig', () => {
          config = this.loadConfig
        }).then(() => {
          // 読込済の場合は無視
          if (this.utils.array.equals(config, this.loadedConfig)) {
            return
          }
          // 倍率が変わらず、移動距離が短い場合は無視
          if (this.loadedConfig !== null &&
                  this.loadedConfig.lat - reload <= config.lat && config.lat <= this.loadedConfig.lat + reload &&
                  this.loadedConfig.lng - reload <= config.lng && config.lng <= this.loadedConfig.lng + reload &&
                  this.loadedConfig.radius === config.radius) {
            return
          }

          // 読込
          return this.api.shopList({
            mapLatitude: config.lat,
            mapLongitude: config.lng,
            radius: config.radius,
            dateFrom: this.utils.cast.dateString(this.$store.getters.forms_search.dateFrom),
            dateTo: this.utils.cast.dateString(this.$store.getters.forms_search.dateTo),
            quantity: this.utils.cast.int(this.$store.getters.forms_search.quantity)
          }).then(response => {
            this.loadedConfig = this.utils.array.clone(config)
            this.markerList = this.convertShopToMap(response.data)
          })
        })
      })
    },
    /**
     * 画面表示用にコンバート
     */
    convertShopToMap (list) {
      return list.filter(item => item.tel !== process.env.VUE_APP_DEV_TEL).map((shop, index) => {
        let zIndex
        let icon
        if (index < 2) {
          zIndex = 10 - index
          icon = require(`@/assets/images/map-marker${index + 1}.png`)
        } else {
          zIndex = 1
          icon = require(`@/assets/images/map-marker.png`)
        }
        let startTime = null
        let endTime = null
        if (shop.shopOpenTimeList) {
          const startTimeList = Array.from(shop.shopOpenTimeList, (item, index) => item.startTime)
          const endTimeList = Array.from(shop.shopOpenTimeList, (item, index) => item.endTime)
          startTime = Math.min(...startTimeList)
          endTime = Math.max(...endTimeList)
        }

        return {
          zIndex: zIndex,
          lat: shop.mapLatitude,
          lng: shop.mapLongitude,
          icon: icon,
          info: {
            id: shop.shopId,
            title: shop.shopName,
            subTitle: shop.industryName,
            img: shop.imgSrc ? `data:image/png;base64,${shop.imgSrc}` : require(`@/assets/images/shop-empty.png`),
            startTime,
            endTime,
            route: {name: 'ShopDetail', params: {id: shop.shopId}}
          }
        }
      })
    },
    /**
     * 倍率を読込範囲に変換
     */
    zoomToRadius (zoom) {
      if (zoom >= 16) {
        return 0.5
      } else if (zoom === 15) {
        return 1
      } else if (zoom === 14) {
        return 2
      } else if (zoom === 13) {
        return 5
      } else if (zoom === 12) {
        return 8
      } else {
        return 20
      }
    },
    /**
     * 地図移動時
     */
    onMapMove (value) {
      this.lock.acquire('loadConfig', () => {
        this.loadConfig.lat = value.lat()
        this.loadConfig.lng = value.lng()
      }).then(() => {
        this.loadShop()
      })
    },
    /**
     * 地図の倍率変更時
     */
    onMapZoom (value) {
      this.lock.acquire('loadConfig', () => {
        this.loadConfig.radius = this.zoomToRadius(value)
      }).then(() => {
        this.loadShop()
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.googlemap
  width: 100vw
  height: calc(100vh - 48px - 240px)

  &.full
    height: calc(100vh - 48px)

.shop-list
  position: relative
  height: 248px
</style>
